import personImage from '../../../assets/auth/person.png'

type BiometricPreviewProps = {
  isReady: boolean
  size?: 'default' | 'compact'
}

export function BiometricPreview({ isReady, size = 'default' }: BiometricPreviewProps) {
  const sizeClassName =
    size === 'compact' ? 'h-[9.5rem] w-[9.5rem]' : 'h-[12.25rem] w-[12.25rem] max-md:h-40 max-md:w-40'

  const ringBeforeClassName = isReady
    ? "before:[background:conic-gradient(var(--color-brand-primary)_0deg_360deg)]"
    : "before:[background:conic-gradient(from_-90deg,var(--color-brand-primary)_0deg_86deg,rgba(0,102,170,0)_86deg_360deg)] before:animate-[biometric-spin_1.4s_linear_infinite]"

  return (
    <div className={`inline-flex items-center justify-center ${sizeClassName}`}>
      <div
        className={`relative flex h-full w-full items-center justify-center rounded-full before:absolute before:inset-0 before:rounded-full before:content-[''] ${ringBeforeClassName}`}
      >
        <div className="relative z-[1] flex h-[95%] w-[95%] items-center justify-center overflow-hidden rounded-full bg-[#79c4f6]">
          <img
            className="block h-full w-full object-cover"
            src={personImage}
            alt=""
            aria-hidden="true"
          />
        </div>
      </div>
    </div>
  )
}
